import * as React from "react";
import { Image } from "react-bootstrap";
import { DriveWatchedMessages } from "src/common";
import empty from "src/assets/images/watched_list_empty.svg";

function EmptyFolderComponent(props: { message?: string }) {
  return <div className="list-messages">
    <div className="center-vertical">
      <Image alt="Watch list is Empty" src={empty} className="my-1 my-md-4" />
      <p>{!!props.message ? props.message : DriveWatchedMessages.watched_list_empty}</p>
    </div>
  </div>;
}

export default React.memo(EmptyFolderComponent);
